import { ReactNode } from "react";
import { cn } from "@edusogno/lib/utils";
import Button from "@edusogno/primitives/button.js";

interface PayNowNotificationItemProps {
  text: ReactNode;
  color?: string | undefined | null;
  border?: string | undefined | null;
  buttonText: string | undefined | null;
  background?: string | undefined | null;
  buttonColor?: string | undefined | null;
  borderButton?: string | undefined | null;
  handleComplete?: () => void;
  buttonBackground?: string | undefined | null;
}

const StaticNotificationItem: React.FC<PayNowNotificationItemProps> = ({
  text,
  color,
  border,
  buttonText,
  background,
  buttonColor,
  borderButton,
  handleComplete,
  buttonBackground,
}) => {
  return (
    <div
      className={cn(
        "rounded-[8px] @container py-2 px-3 flex flex-row gap-5 border-2 border-[--secondary] w-full items-center",
        border,
        background,
      )}
    >
      <p
        className={cn(
          "text-[10px] @2xl:text-[12px] leading-[1.2] flex-[0.9] @2xl:flex-[0.8] font-400 tracking-[0.05em]",
          color,
        )}
      >
        {text}
      </p>

      <Button
        size="md"
        color="primary"
        variant="outlined"
        onClick={handleComplete}
        className={cn(
          "ml-auto text-[11px] min-w-[70px] @xl:min-w-[100px] @xl:text-[12px] flex-[0.1] @2xl:flex-[0.2] border-2 border-[--secondary]",
          buttonColor,
          borderButton,
          buttonBackground,
        )}
      >
        {buttonText}
      </Button>
    </div>
  );
};

export default StaticNotificationItem;
